module.exports = __webpack_public_path__ + "img/aboutme.1424bff6.jpg";